// extracted by mini-css-extract-plugin
module.exports = {"container":"Navbar_container__1ESpZ","logo":"Navbar_logo__1H3m4","logo__animate":"Navbar_logo__animate__1YaUL"};